export const ID_TOKEN_SUFFIX = `_${window.btoa('idToken')}`;
export const ACCESS_TOKEN_SUFFIX = `_${window.btoa('accessToken')}`;

export const TID_USERNAME_KEY = 'tidUsername';

export const TID_ID_TOKEN_KEY = (userId: number) =>
  `${window.btoa(userId.toString())}${ID_TOKEN_SUFFIX}`;

export const TID_ACCESS_TOKEN_KEY = (userId: number) =>
  `${window.btoa(userId.toString())}${ACCESS_TOKEN_SUFFIX}`;
